<template lang="pug">
div
  .counters(:class="standalone ? '' : 'columns'")
    .column
      .counter(:class="standalone ? 'counter-standalone' : 'has--label'" :style="standalone ? '' : ('background-image: url('+settings.menu_image+');')")
        button.btn.is--minus.is--icon.is--inverted(type='button' @click="menuMinus")
          svg(fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg')
            path(d='M5.5 12.7499V11.25H18.5V12.7499H5.5Z')
        .input-wrapper
          label.is--floating.is--active(for='menu_count_classic') Klassische&nbsp;Menüs
          input(type='number' id='menu_count' name='order_item[menu_count_classic]' :min='menuMin' :max='menuMax' step='1' v-model="menuCount" required="")
        button.btn.is--plus.is--icon.is--inverted(type='button' @click="menuAdd")
          svg(fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg')
            path(d='M11.25 12.75H5.5V11.25H11.25V5.5H12.7499V11.25H18.5V12.75H12.7499V18.5H11.25V12.75Z')
    .column
      .counter(:class="standalone ? 'counter-standalone' : 'has--label'" :style="standalone ? '' : ('background-image: url('+settings.vegan_image+');')")
        button.btn.is--minus.is--icon.is--inverted(type='button' @click="vgeanMinus")
          svg(fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg')
            path(d='M5.5 12.7499V11.25H18.5V12.7499H5.5Z')
        .input-wrapper
          label.is--floating.is--active.veggie(for='menu_count_veggie') Vegetar.&nbsp;/&nbsp;Vegane&nbsp;Menüs
          input(type='number' id='vegan_count' name='order_item[menu_count_veggie]' :min='veganMin' :max='veganMax' step='1' v-model="veganCount" required="")
        button.btn.is--plus.is--icon.is--inverted(type='button' @click="vgeanAdd")
          svg(fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg')
            path(d='M11.25 12.75H5.5V11.25H11.25V5.5H12.7499V11.25H18.5V12.75H12.7499V18.5H11.25V12.75Z')
      
  div(style="display: flex; align-items: center; justify-content: center; margin-top: -25px;" v-if="!standalone")
    .icon-text.font-size--small.fill--white
      svg(fill='none' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg')
        path(d='M11.25 16.75H12.75V11H11.25V16.75ZM12 9.28845C12.2288 9.28845 12.4207 9.21105 12.5755 9.05625C12.7303 8.90145 12.8077 8.70963 12.8077 8.48078C12.8077 8.25194 12.7303 8.06012 12.5755 7.9053C12.4207 7.7505 12.2288 7.6731 12 7.6731C11.7711 7.6731 11.5793 7.7505 11.4245 7.9053C11.2697 8.06012 11.1923 8.25194 11.1923 8.48078C11.1923 8.70963 11.2697 8.90145 11.4245 9.05625C11.5793 9.21105 11.7711 9.28845 12 9.28845ZM12.0016 21.5C10.6877 21.5 9.45268 21.2506 8.29655 20.752C7.1404 20.2533 6.13472 19.5765 5.2795 18.7217C4.42427 17.8669 3.74721 16.8616 3.24833 15.706C2.74944 14.5504 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45268 3.248 8.29655C3.74667 7.1404 4.42342 6.13472 5.27825 5.2795C6.1331 4.42427 7.13834 3.74721 8.29398 3.24833C9.44959 2.74944 10.6844 2.5 11.9983 2.5C13.3122 2.5 14.5473 2.74933 15.7034 3.248C16.8596 3.74667 17.8652 4.42342 18.7205 5.27825C19.5757 6.1331 20.2527 7.13834 20.7516 8.29398C21.2505 9.44959 21.5 10.6844 21.5 11.9983C21.5 13.3122 21.2506 14.5473 20.752 15.7034C20.2533 16.8596 19.5765 17.8652 18.7217 18.7205C17.8669 19.5757 16.8616 20.2527 15.706 20.7516C14.5504 21.2505 13.3156 21.5 12.0016 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76664 19.225 7.87498 17.675 6.32498C16.125 4.77498 14.2333 3.99998 12 3.99998C9.76664 3.99998 7.87498 4.77498 6.32498 6.32498C4.77498 7.87498 3.99998 9.76664 3.99998 12C3.99998 14.2333 4.77498 16.125 6.32498 17.675C7.87498 19.225 9.76664 20 12 20Z')
      .text-content
        p Sie können die Menü Verteilung bis 7 Tage vor der Veranstaltung anpassen.

  intolerances(
    v-model:buttonDisabled="_buttonDisabled"
    :menu-count="menuCount"
    :vegan-count="veganCount"
    v-model="intolerances"
  )
  div(v-html="html" v-if="settings.html && html && html.length != 0")
  button#submit.btn.is--inverted(:type="_buttonDisabled ? 'button' : 'submit'" v-if="standalone" style="margin-top: 30px;"  :class="_buttonDisabled ? 'is--disabled' : ''"): span Speichern
</template>

<script>
import Intolerances from '../Components/Intolerances.vue'
export default {
  components: {
    Intolerances
  },
  props: [
    "settings",
    "count",
    "buttonDisabled",
    "order",
    "html",
    "standalone"
  ],
  data () {
    return {
      ready: false,
      menuCount: 0,
      veganCount: 0,
      intolerances: [],
      _buttonDisabled: null,
    }
  },
  mounted () {
    this._buttonDisabled = this.buttonDisabled
    this.menuCount = this.count
    if (this.standalone) {
      if (this.order.menu_count_classic || this.order.menu_count_classic === 0) this.menuCount = this.order.menu_count_classic
      if (this.order.menu_count_veggie || this.order.menu_count_veggie === 0)  this.veganCount = this.order.menu_count_veggie
    } else {
      if (this.order.menu_count_classic) this.menuCount = this.order.menu_count_classic
      if (this.order.menu_count_veggie)  this.veganCount = this.order.menu_count_veggie
    }

    if (this.order.intolerances && this.order.intolerances.length != 0){
      if (typeof(this.order.intolerances) == "string"){
        this.intolerances = JSON.parse(this.order.intolerances)
      } else {
        this.intolerances = this.order.intolerances
      }
    }

    setTimeout(() => {
      this.ready = true
    }, 100)
  },
  watch: {
    count(){
      if (!this.ready) return false
      if (!this.standalone) this.menuCount = this.count
    },
    menuCount(){
      if (!this.ready) return false
      this.veganCount = this.count - this.menuCount
    },
    veganCount(){
      if (!this.ready) return false
      this.menuCount = this.count - this.veganCount
    },
    _buttonDisabled(){
      this.$emit('update:buttonDisabled', this._buttonDisabled)
    }
  },
  computed: {
    menuMin(){
      return 0
    },
    menuMax(){
      return this.count
    },
    veganMin(){
      return 0
    },
    veganMax(){
      return this.count
    },
  },
  methods: {
    vgeanMinus(){
      if (this.veganCount == this.veganMin) return false
      this.veganCount--
    },
    vgeanAdd(){
      if (this.veganCount == this.veganMax) return false
      this.veganCount++
    },
    menuMinus(){
      if (this.menuCount == this.menuMin) return false
      this.menuCount--
    },
    menuAdd(){
      if (this.menuCount == this.menuMax) return false
      this.menuCount++
    },
  }
}
</script>
<style>
@media only screen and (max-width: 524px) {
  .is--floating.is--active.veggie{
    transform-origin: top left !important;
  }
}
</style>
